import { useEffect, useState } from 'react';

import { useMst } from '../../mobx-models/Root';
import useBorerShiftCrew from '../../rxdb/BorerShiftCrew/useBorerShiftCrew';

export const useCrewAssignedForShift = (): boolean => {
  const { shiftPicker } = useMst();

  const [crewAssigned, setCrewAssigned] = useState(true);
  const { getBorerShiftCrews, borerShiftCrewInitialized } = useBorerShiftCrew();

  useEffect(() => {
    const checkIfCrewMissing = async () => {
      if (shiftPicker.currentBorerShiftId && borerShiftCrewInitialized) {
        const { borerShiftCrews } = await getBorerShiftCrews(shiftPicker.currentBorerShiftId);

        if (shiftPicker.isCurrentShiftSelected() && !borerShiftCrews?.length) {
          setCrewAssigned(false);
        } else {
          setCrewAssigned(true);
        }
      }
    };
    checkIfCrewMissing();
  }, [shiftPicker.currentBorerShiftId, borerShiftCrewInitialized]);

  return crewAssigned;
};

export default useCrewAssignedForShift;
